// 客户信息渠道转成交统计
export default {
  field_from_api: {
    clue: {
      name: '线索',
      map: {
        count: {
          name: '合计'
        },
        rate: {
          name: '占比'
        }
      }
    },
    arrived: {
      name: '到店',
      map: {
        count: {
          name: '合计'
        },
        rate: {
          name: '到店率'
        }
      }
    },
    deal: {
      name: '成交',
      map: {
        count: {
          name: '合计'
        },
        rate: {
          name: '成交率'
        }
      }
    },
    clue_to_deal_rate: {
      name: '线索转化率',
      map: {}
    }
  },
  getData (params) {
    this.$rest.dataAnalysis.getChannelAnalysis(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
